import { Button, ButtonProps } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

type EllipsisButtonProps = ButtonProps;

function EllipsisButton(props: EllipsisButtonProps) {
  return <Button type="link" icon={<FilterOutlined />} {...props} />;
}

export default EllipsisButton;
